import { API, Endpoints } from "@brg/api";
import { useProfile } from "@brg/auth";
import { useToasts } from "@brg/ui";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FolderEditT, FolderT } from "shared/pages/designer/components/tabs/const";
import ProfileFoldersSlice, { ProfileFoldersProps, ProfileFoldersSelector } from "shared/reducers/ProfileFoldersSlice";
import useQueryState from "./useQueryState";
import { useDispatch, useSelector } from "react-redux";
import { MAX_FOLDERS_COUNT } from "shared/pages/designer/components/DesignerFolders/DesignerFolders";

interface FolderHandlersProps {
    onFolderChange: (s:ProfileFoldersProps, folderId?: string) => void,
    onGet: (id: string, callback: (data: FolderT) => void) => void,
    onDelete: (id: string, noToast?: boolean) => Promise<any>,
    onEdit: (data: FolderT, type: any, noToast?: boolean) => Promise<any>,
    onCreate: (folder: FolderEditT) => void,
    onAddProject: (folder: FolderT, noToast?: boolean) => Promise<any>,
    onRemoveProject: (folder: FolderT, noToast?: boolean) => Promise<any>,
    onMoveProject: (folder: FolderT) => Promise<any>,
}


export const useFoldersController = (): FolderHandlersProps => {
    const { t, i18n } = useTranslation();
    const profile = useProfile();
    const dispatch = useDispatch();
    const [{}, setQueryParams] = useQueryState();
    const { info, error } = useToasts();
    const { foldersList } = useSelector(ProfileFoldersSelector)

    const onFolderChange = (s:ProfileFoldersProps, folderId?: string) => {
        if (folderId) {
            setQueryParams({ folderId })
        }

        dispatch(ProfileFoldersSlice.actions.setCurrentFolder(s))
    }

    const onGet = useCallback((id: string, callback: (data: FolderT) => void) => {
        if (profile?.accountId) {
            API.request()
                .endpoint(Endpoints.folders)
                .url('/api/Folder/GetFolder')
                .addQuery('folderId', id)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    callback(API.toLang(r, i18n.language))
                })
        }
    } , [])

    const onDelete = useCallback(
        async (id: string, noToast?: boolean ) => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/DeleteFolder`, {
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(id)
            }).then((r) => {
                if (!noToast && r?.status === 200) {
                    info(t('folders.modal.success_delete_folder'))
                }

                return r;
            })
    } ,[])
    
    const onEdit = useCallback(
        async (data: FolderT, type: any, noToast?: boolean): Promise<any> => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/UpdateFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(data),
            })
            .then((r) => {
                if (r?.status === 200) {
                    !noToast && info(t('folders.modal.success_edit'))
                }

                return r
            })
    }, [])

    const onCreate = useCallback(
        (folder: FolderEditT) => {
            API.request()
                .endpoint(Endpoints.folders)
                .url('/api/Folder/CreateFolder')
                .body(folder)
                .post()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    if (r?.message === 'Too many folders') {
                        error(t('folders.msg.max_folders', { count: MAX_FOLDERS_COUNT }))
                        return;
                    }
                })
    } ,[])

    const onAddProject = useCallback(
        async (folder: FolderT, noToast?: boolean) => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/AddEntityIdsForFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify({ 
                    folderId: folder?.id, 
                    entityIds: folder?.entityIds 
                })
            }).then((r) => {
                if (r?.status === 200) {
                    !noToast && info(t('folders.modal.success_add', { name: folder?.name ?? ''}))
                }
                return r;
            })
        } , [])
    
    const onRemoveProject = useCallback(
        async (folder: FolderT, noToast?: boolean ) => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/DeleteEntityIdsForFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify({ 
                    folderId: folder?.id, 
                    entityIds: folder?.entityIds 
                })
            }).then((r) => {
                if (r?.status === 200) {
                    !noToast && info(t('folders.modal.success_delete', { name: folder?.name ?? ''}))
                }
                return r;
            })
        } , [])

    const onMoveProject = useCallback(
        async (folder: FolderT) => {
            const fl = foldersList?.find((f) => f?.id === folder?.id);
            const isEqual = JSON.stringify(fl?.entityIds) === JSON.stringify(folder?.entityIds)

            if (isEqual) {
                return null;
            }
            return await API.fetch(`${Endpoints.folders}/api/Folder/UpdateFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(folder),
            })
            .then((r) => r)
        } , [foldersList])
    
    return {
        onDelete,
        onEdit,
        onGet,
        onCreate,
        onAddProject,
        onRemoveProject,
        onMoveProject,
        onFolderChange
    }
}import { API, Endpoints } from "@brg/api";
import { useProfile } from "@brg/auth";
import { useToasts } from "@brg/ui";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FolderEditT, FolderT } from "shared/pages/designer/components/tabs/const";
import ProfileFoldersSlice, { ProfileFoldersProps, ProfileFoldersSelector } from "shared/reducers/ProfileFoldersSlice";
import useQueryState from "./useQueryState";
import { useDispatch, useSelector } from "react-redux";
import { MAX_FOLDERS_COUNT } from "shared/pages/designer/components/DesignerFolders/DesignerFolders";

interface FolderHandlersProps {
    onFolderChange: (s:ProfileFoldersProps, folderId?: string) => void,
    onGet: (id: string, callback: (data: FolderT) => void) => void,
    onDelete: (id: string, noToast?: boolean) => Promise<any>,
    onEdit: (data: FolderT, type: any, noToast?: boolean) => Promise<any>,
    onCreate: (folder: FolderEditT) => void,
    onAddProject: (folder: FolderT, noToast?: boolean) => Promise<any>,
    onRemoveProject: (folder: FolderT, noToast?: boolean) => Promise<any>,
    onMoveProject: (folder: FolderT) => Promise<any>,
}


export const useFoldersController = (): FolderHandlersProps => {
    const { t, i18n } = useTranslation();
    const profile = useProfile();
    const dispatch = useDispatch();
    const [{}, setQueryParams] = useQueryState();
    const { info, error } = useToasts();
    const { foldersList } = useSelector(ProfileFoldersSelector)

    const onFolderChange = (s:ProfileFoldersProps, folderId?: string) => {
        if (folderId) {
            setQueryParams({ folderId })
        }

        dispatch(ProfileFoldersSlice.actions.setCurrentFolder(s))
    }

    const onGet = useCallback((id: string, callback: (data: FolderT) => void) => {
        if (profile?.accountId) {
            API.request()
                .endpoint(Endpoints.folders)
                .url('/api/Folder/GetFolder')
                .addQuery('folderId', id)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    callback(API.toLang(r, i18n.language))
                })
        }
    } , [])

    const onDelete = useCallback(
        async (id: string, noToast?: boolean ) => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/DeleteFolder`, {
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(id)
            }).then((r) => {
                if (!noToast && r?.status === 200) {
                    info(t('folders.modal.success_delete_folder'))
                }

                return r;
            })
    } ,[])
    
    const onEdit = useCallback(
        async (data: FolderT, type: any, noToast?: boolean): Promise<any> => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/UpdateFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(data),
            })
            .then((r) => {
                if (r?.status === 200) {
                    !noToast && info(t('folders.modal.success_edit'))
                }

                return r
            })
    }, [])

    const onCreate = useCallback(
        (folder: FolderEditT) => {
            API.request()
                .endpoint(Endpoints.folders)
                .url('/api/Folder/CreateFolder')
                .body(folder)
                .post()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    if (r?.message === 'Too many folders') {
                        error(t('folders.msg.max_folders', { count: MAX_FOLDERS_COUNT }))
                        return;
                    }
                })
    } ,[])

    const onAddProject = useCallback(
        async (folder: FolderT, noToast?: boolean) => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/AddEntityIdsForFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify({ 
                    folderId: folder?.id, 
                    entityIds: folder?.entityIds 
                })
            }).then((r) => {
                if (r?.status === 200) {
                    !noToast && info(t('folders.modal.success_add', { name: folder?.name ?? ''}))
                }
                return r;
            })
        } , [])
    
    const onRemoveProject = useCallback(
        async (folder: FolderT, noToast?: boolean ) => {
            return await API.fetch(`${Endpoints.folders}/api/Folder/DeleteEntityIdsForFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify({ 
                    folderId: folder?.id, 
                    entityIds: folder?.entityIds 
                })
            }).then((r) => {
                if (r?.status === 200) {
                    !noToast && info(t('folders.modal.success_delete', { name: folder?.name ?? ''}))
                }
                return r;
            })
        } , [])

    const onMoveProject = useCallback(
        async (folder: FolderT) => {
            const fl = foldersList?.find((f) => f?.id === folder?.id);
            const isEqual = JSON.stringify(fl?.entityIds) === JSON.stringify(folder?.entityIds)

            if (isEqual) {
                return null;
            }
            return await API.fetch(`${Endpoints.folders}/api/Folder/UpdateFolder`, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(folder),
            })
            .then((r) => r)
        } , [foldersList])
    
    return {
        onDelete,
        onEdit,
        onGet,
        onCreate,
        onAddProject,
        onRemoveProject,
        onMoveProject,
        onFolderChange
    }
}